import { Box, Flex } from "@chakra-ui/react";
import { Col, Row } from "antd";
import Field from "components/Input/Field";
import SelectContaBancaria from "components/Input/SelectContaBancaria";
import SelectParametrosJuros from "components/Input/SelectParametrosJuros";
import SelectSetorCobranca from "components/Input/SelectSetorCobranca";
import InputMask from "ui/components/Input/InputMask";
import { FiltrosAdicionaisProps } from "./../FiltrosAdicionais";
import SelectContaCategoria from "ui/components/Input/SelectContaCategoria";
import SelectCentroDeCusto from "../../../../../../../../../components/Input/SelectCentroDeCusto/index";

function FiltrosAdicionaisInadimplentes({
  index,
  control,
}: FiltrosAdicionaisProps) {
  return (
    <Flex flexDir="column">
      <Box as={Row} gutter={16} mb={4}>
        <Box as={Col} xs={24}>
          <Field
            control={control}
            name={`items.${index}.parametros.filtrosAdicionais.search`}
            label="Busca"
          />
        </Box>
      </Box>

      <Box as={Row} gutter={16} mb={4}>
        <Box as={Col} xs={24}>
          <Field
            control={control}
            name={`items.${index}.parametros.filtrosAdicionais.setor`}
            label="Setor de cobrança"
            render={({ field }) => <SelectSetorCobranca {...field} />}
          />
        </Box>
      </Box>

      <Box as={Row} gutter={16} mb={4}>
        <Box as={Col} xs={12}>
          <Field
            control={control}
            name={`items.${index}.parametros.filtrosAdicionais.contasBancariasIds`}
            label="Contas bancárias"
            render={({ field }) => (
              <SelectContaBancaria {...field} mode="multiple" />
            )}
          />
        </Box>
        <Box as={Col} xs={12}>
          <Field
            control={control}
            name={`items.${index}.parametros.filtrosAdicionais.contasCategoriasIds`}
            label="Contas categorias"
            render={({ field }) => <SelectContaCategoria {...field} multiple />}
          />
        </Box>
      </Box>

      <Box as={Row} gutter={16} mb={4}>
        <Box as={Col} xs={12}>
          <Field
            control={control}
            name={`items.${index}.parametros.filtrosAdicionais.cpf`}
            label="CPF"
            render={({ field }) => (
              <InputMask
                {...field}
                mask="999.999.999-99"
                placeholder="XXX.XXX.XXX-XX"
              />
            )}
          />
        </Box>

        <Box as={Col} xs={12}>
          <Field
            control={control}
            name={`items.${index}.parametros.filtrosAdicionais.porcentagemHonorarios`}
            label="% Honorários"
            render={({ field }) => <SelectParametrosJuros {...field} />}
          />
        </Box>
      </Box>

      <Box as={Row} gutter={16} mb={4}>
        <Box as={Col} xs={12}>
          <Field
            control={control}
            name={`items.${index}.parametros.filtrosAdicionais.centrosDeCustoIds`}
            label="Centros de custo"
            render={({ field }) => (
              <SelectCentroDeCusto mode="multiple" {...field} />
            )}
          />
        </Box>
      </Box>
    </Flex>
  );
}

export default FiltrosAdicionaisInadimplentes;
